import { Controller } from "@hotwired/stimulus"

// Opens the « + Coffret » <dialog> instead of following the link (the link is the no-JS path).
// No optional chaining: Webpacker 5 does not transpile it.
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    if (!this.hasDialogTarget || typeof this.dialogTarget.showModal !== "function") return

    event.preventDefault()
    this.dialogTarget.showModal()
  }

  close() {
    if (this.hasDialogTarget) this.dialogTarget.close()
  }

  // A click on the backdrop lands on the <dialog> element itself, never on its content.
  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
